import { render, staticRenderFns } from "./WaybillGroupCustomerDetailCodeView.vue?vue&type=template&id=135600dc&"
import script from "./WaybillGroupCustomerDetailCodeView.vue?vue&type=script&lang=js&"
export * from "./WaybillGroupCustomerDetailCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports